import questionTypes from '../questionTypes';

import {
  getSocialDefaultProps,
  socialMediaTypeList,
} from '../../config/socialMediaConfig';
import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export const displayList = [
  {
    value: true,
    label: 'Show labels',
  },
  {
    value: false,
    label: 'Hide labels',
  },
];

export default {
  type: questionTypes.socialFollow,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    layout: 'horizontal',
    alignment: 'center',
    display: true,
    buttons: [getSocialDefaultProps(socialMediaTypeList.facebook)],
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => false,
  },
};
